import { render } from "./StoreTransferListView.vue?vue&type=template&id=13f13a87"
import script from "./StoreTransferListView.vue?vue&type=script&lang=js"
export * from "./StoreTransferListView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__